/**
 * 处理添加购物车操作
 */
/**
 * 重新分配主商品表单中附加商品字段的索引。
 * 固定优先级：勘测服务 → 安装服务 → 推荐商品；跳过禁用或空值字段，保证索引从 1 连续。
 * @param {HTMLFormElement} form 主商品表单。
 */
window.assignAdditionalItemIndexes = function (form) {
  if (!form) return;

  // 附加商品字段，按固定优先级排列。
  const pairs = [];

  // 勘测服务和安装服务的独立隐藏字段。
  [
    form.querySelector('[data-survey-service-additional-item]'),
    form.querySelector('[data-install-service-additional-item]'),
  ].forEach((input) => {
    if (input && !input.disabled && input.value) pairs.push({ id: input, quantity: null });
  });

  // 推荐商品容器内的成对 id/quantity 字段。
  const container = form.querySelector('[data-recommended-additional-items]');
  if (container) {
    container.querySelectorAll('input[name$="[id]"]').forEach((idInput) => {
      const match = idInput.name.match(/\[(\d+)\]\[id\]$/);
      const quantity = match && container.querySelector(`input[name="shopify-additional-items[${match[1]}][quantity]"]`);
      pairs.push({ id: idInput, quantity: quantity || null });
    });
  }

  // 从 1 开始连续重写索引。
  pairs.forEach((pair, index) => {
    pair.id.name = `shopify-additional-items[${index + 1}][id]`;
    if (pair.quantity) pair.quantity.name = `shopify-additional-items[${index + 1}][quantity]`;
  });
};

if (!customElements.get('product-form')) {
    customElements.define(
        'product-form',
        class ProductForm extends HTMLElement {
            constructor() {
                super();
                this.form = this.querySelector('form');
                if(!this.form) return;

                this.isloading = false;
                this.error = false;
                this.variantIdInput.disabled = false;
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this)); // 添加提交购物车监听

                this.addCartButtons = this.querySelectorAll('button[type="submit"]'); // 添加购物车按钮，可能有多处按钮

                this.cartDrawer = document.getElementById('Cart-Drawer');
                if (this.cartDrawer && !this.cartDrawer.hasAttribute('data-status-silence')) this.addCartButtons.forEach(button=>{
                    button.setAttribute('aria-haspopup', 'dialog');
                    button.setAttribute('aria-expanded', 'false');
                    button.setAttribute('aria-controls', 'Cart-Drawer');
                });

                this.errorMessageWrapper = document.getElementById(`Product-Form-Error-Message-${this.dataset.section}`);
                // 快速购物弹窗
                this.quickAddDrawer = this.closest('product-side-drawer');

                // 迷你结账
                this.miniChecker = document.getElementById(`Product-Mini-Checkout-${this.dataset.section}`);
                if(this.miniChecker) {
                    this.miniCheckerObserver = new IntersectionObserver((entries, observer)=>{
                        if(entries[0].isIntersecting) {
                            this.hideMiniCheck();
                        } else if (entries[0].boundingClientRect.top < 0){
                            this.showMiniCheck();
                        }
                    }, {
                        root: null,
                        rootMargin: '-200px 0px 0px 0px'
                    });

                    this.miniCheckerObserver.observe(this);
                }
                
                // 配送状态
                this.deliveryState = {
                    specialDelivery: null,
                    normalDelivery: null
                };
                
                // 监听配送状态变化
                this.setupDeliveryListeners();
            }

            disconnectedCallback() {
                if(this.miniCheckerObserver) this.miniCheckerObserver.disconnect();
            }

            get variantIdInput() {
                return this.form.querySelector('[name=id]');
            }
            
            /**
             * 是否隐藏错误信息
             * 当产品是礼品卡的时候，隐藏错误信息
             * @returns {boolean}
             */
            get hideErrors() {
                return this.dataset.hideErrors === 'true';
            }
            
            /**
             * 设置配送状态监听器
             */
            setupDeliveryListeners() {
                // 监听特惠配送状态变化
                document.addEventListener('special-delivery:state-changed', (event) => {
                    this.deliveryState.specialDelivery = event.detail.canAddSpecialDelivery ? 
                        event.detail.specialDelivery : null;
                });
                
                // 监听普通配送状态变化
                document.addEventListener('normal-delivery:state-changed', (event) => {
                    this.deliveryState.normalDelivery = event.detail.canAddNormalDelivery ? 
                        event.detail.normalDelivery : null;
                });
            }

            /**
             * 处理点击提交购物车
             * @param event
             */
            onSubmitHandler(event) {
                if(this.isloading) return;
                event.preventDefault();
                if(Array.from(this.addCartButtons).find(button => button.hasAttribute('disabled'))) return;

                this.handleErrorMessage();
                
                // 获取配送方式信息（自提点为可选）
                const deliveryMethodField = this.form.querySelector('[name="attributes[delivery_method]"]');
                
                this.startLoading();

                // 检查是否有选中的自提点变体ID和具体自提点信息
                const storeIdField = this.form.querySelector('[name="attributes[pickup_store_id]"]');
                const hasPickupStoreVariant = window.selectedPickupStoreVariantId && 
                    deliveryMethodField && deliveryMethodField.value === 'pickup' &&
                    storeIdField && storeIdField.value;

                // 检查是否有特惠配送
                const hasSpecialDelivery = this.deliveryState.specialDelivery && 
                    deliveryMethodField && deliveryMethodField.value === 'special';
                    
                // 检查是否有普通配送
                const hasNormalDelivery = this.deliveryState.normalDelivery && 
                    deliveryMethodField && deliveryMethodField.value === 'time';

                if (hasPickupStoreVariant) {
                    // 如果选择了具体自提点，同时添加主产品和自提点关联产品
                    this.addMultipleProductsToCart(event, 'pickup');
                } else if (hasSpecialDelivery) {
                    // 如果选择了特惠配送，同时添加主产品和特惠配送关联产品
                    this.addMultipleProductsToCart(event, 'special');
                } else if (hasNormalDelivery) {
                    // 如果选择了普通配送，同时添加主产品和普通配送关联产品
                    this.addMultipleProductsToCart(event, 'normal');
                } else {
                    // 原有的单产品添加逻辑
                    const config = fetchConfig('javascript');
                    config.headers['X-Requested-With'] = 'XMLHttpRequest';
                    delete config.headers['Content-Type'];  /* 浏览器会自动为 formData 对象生成带有边界(boundary)的 multipart/form-data 类型*/

                    const formData = new FormData(this.form);
                    formData.append('sections', this.getSectionsToRender().map((section)=>section.section).join());
                    formData.append('sections_url', window.location.pathname);
                    config.body = formData;

                    fetch(`${window['routes']['cart_add_url']}`, config)
                        .then((response) => {
                            return response.json();
                        })
                        .then((response) => {
                            if (response.status) {
                                publish(PUB_SUB_EVENTS.cartError, {
                                    source: 'product-form',
                                    productVariantId: formData.get('id'),
                                    errors: response.errors || response.description,
                                    message: response.message,
                                });
                                this.handleErrorMessage(response.description);
                                return this.error = true;
                            }
                            this.error = false;

                            // 动态更新Sections内容
                            SectionDynamicUpdate.updateSections(this.getSectionsToRender(), response['sections']);

                            publish(PUB_SUB_EVENTS.cartUpdate, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                cartData: response,
                            });
                            if(this.cartDrawer && !this.cartDrawer.hasAttribute('data-status-silence')) {
                                // 打开抽屉
                                this.cartDrawer.show(event.submitter);
                            } else {
                                return window.location = window['routes']['cart_url'];
                            }
                        })
                        .catch((e) => {
                            this.handleErrorMessage(window['variantStrings']['unknownError']);
                            this.error = true;
                        })
                        .finally(()=>{
                            this.endLoading();
                            // 关闭迷你结账
                            this.hideMiniCheck();
                        });
                }
            }

            /**
             * 获取需要重新渲染的位置
             * @returns {[{section: string, selector: string, id: string}]}
             */
            getSectionsToRender() {
                const sections = [
                    {
                        id: 'Cart-Icon-Bubble',
                        section: 'cart-icon-bubble',
                        selector: '.shopify-section'
                    }
                ];

                if(this.cartDrawer && !this.cartDrawer.hasAttribute('data-status-silence')) {
                    sections.push({
                        id: 'Cart-Drawer',
                        section: this.cartDrawer.dataset.section,
                        selector: '#Cart-Drawer-Details',
                    });
                }

                return sections;
            }

            /**
             * 错误显示
             * @param errorMessage
             */
            handleErrorMessage(errorMessage = null) {
                if (this.hideErrors || !this.errorMessageWrapper) return;

                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
                this.errorMessageWrapper.textContent = errorMessage ? errorMessage : '';
            }

            startLoading() {
                this.isloading = true;

                this.addCartButtons.forEach(button => {
                    button.setAttribute('disabled', 'disabled');
                    button.classList.add('loading');
                });
            }

            endLoading() {
                this.isloading = false;

                this.addCartButtons.forEach(button => {
                    button.removeAttribute('disabled');
                    button.classList.remove('loading');
                });

                // 关闭快速预览
                if(!this.error && this.quickAddDrawer) {
                    this.quickAddDrawer.hide();
                }
            }

            showMiniCheck() {
                if(this.miniChecker) this.miniChecker.classList.add('active');
            }

            hideMiniCheck() {
                if(this.miniChecker) this.miniChecker.classList.remove('active');
            }

            /**
             * 添加多个产品到购物车（主产品 + 配送相关产品）
             * @param {Event} event 提交事件
             * @param {string} type 配送类型：pickup|special|normal
             */
            addMultipleProductsToCart(event, type) {
                // 收集主产品信息
                const formData = new FormData(this.form);
                const mainProductId = formData.get('id');
                const quantity = formData.get('quantity') || 1;
                
                // 构建多产品添加请求
                const items = [
                    {
                        id: mainProductId,
                        quantity: parseInt(quantity)
                    }
                ];
                
                // 根据配送类型添加相应的配送产品
                if (type === 'pickup' && window.selectedPickupStoreVariantId) {
                    items.push({
                        id: window.selectedPickupStoreVariantId,
                        quantity: 1,
                        properties: {
                            '_is_pickup_service': 'true',
                            '_main_product_id': mainProductId
                        }
                    });
                } else if (type === 'special' && this.deliveryState.specialDelivery) {
                    items.push({
                        id: this.deliveryState.specialDelivery.variant,
                        quantity: 1,
                        properties: {
                            '_is_special_delivery': 'true',
                            '_main_product_id': mainProductId,
                            '_special_delivery_price': this.deliveryState.specialDelivery.price
                        }
                    });
                } else if (type === 'normal' && this.deliveryState.normalDelivery) {
                    items.push({
                        id: this.deliveryState.normalDelivery.variant,
                        quantity: 1,
                        properties: {
                            '_is_normal_delivery': 'true',
                            '_main_product_id': mainProductId,
                            '_normal_delivery_price': this.deliveryState.normalDelivery.price
                        }
                    });
                }

                // 收集所有 cart attributes
                const attributes = {};
                for (let [key, value] of formData.entries()) {
                    if (key.startsWith('attributes[')) {
                        const attributeKey = key.match(/attributes\[(.*)\]/)[1];
                        attributes[attributeKey] = value;
                    }
                }

                const config = fetchConfig('javascript');
                config.headers['Content-Type'] = 'application/json';
                
                // 构建包含 items 和 attributes 的请求体
                const requestBody = { 
                    items: items,
                    attributes: attributes
                };
                
                config.body = JSON.stringify(requestBody);

                fetch(`${window['routes']['cart_add_url']}`, config)
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        if (response.status) {
                            publish(PUB_SUB_EVENTS.cartError, {
                                source: 'product-form',
                                productVariantId: mainProductId,
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                            this.handleErrorMessage(response.description);
                            return this.error = true;
                        }
                        this.error = false;

                        // 动态更新Sections内容
                        const sectionsToRender = this.getSectionsToRender();
                        if (sectionsToRender.length > 0) {
                            // 获取更新后的sections
                            fetch(window.location.pathname + '?sections=' + sectionsToRender.map((section)=>section.section).join(','))
                                .then(response => response.json())
                                .then(sections => {
                                    SectionDynamicUpdate.updateSections(sectionsToRender, sections);
                                });
                        }

                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'product-form',
                            productVariantId: mainProductId,
                            cartData: response,
                        });

                        if(this.cartDrawer && !this.cartDrawer.hasAttribute('data-status-silence')) {
                            // 打开抽屉
                            this.cartDrawer.show(event.submitter);
                        } else {
                            return window.location = window['routes']['cart_url'];
                        }
                    })
                    .catch((e) => {
                        console.error('Error adding multiple products to cart:', e);
                        this.handleErrorMessage(window['variantStrings']['unknownError']);
                        this.error = true;
                    })
                    .finally(()=>{
                        this.endLoading();
                        // 关闭迷你结账
                        this.hideMiniCheck();
                    });
            }
        }
    );
}
